import { AllowedAction } from 'api';
//import { FaHome, FaCalendar } from 'react-icons/fa';

import { TbLayoutDashboard } from 'react-icons/tb'; //dashboard icon

import { MdOutlineLocalOffer } from 'react-icons/md'; //offer icon
//import { FaSearch } from 'react-icons/fa'; //search icon

import { GrConfigure } from 'react-icons/gr'; //configurator
//import { GrDocumentConfig } from 'react-icons/gr'; //configurator
import { Menu, MenuItems } from 'design-system/components/SideBar/types';

export const navMenu: MenuItems = [
	{ title: 'Dashboard', type: 'link', href: '/dashboard', actions: [], icon: TbLayoutDashboard },
	{
		title: 'Offer',
		type: 'dropdown',
		href: '/#',
		actions: [],
		icon: MdOutlineLocalOffer, // Assign the proper icon
		submenu: [
			{
				title: 'New Sales Offer',
				type: 'link',
				href: '/offer',
				actions: [AllowedAction.CreateOffer]
			},
			{
				title: 'Search',
				type: 'link',
				href: '/offer-search',
				actions: []
			}
		]
	},
	{
		title: 'Configurator',
		type: 'dropdown',
		href: '/#',
		actions: [AllowedAction.ChangeConfiguration],
		icon: GrConfigure,
		submenu: [
			{
				title: 'System values',
				type: 'link',
				href: '/system-values',
				actions: [AllowedAction.ChangeConfiguration]
			},
			{
				title: 'Portfolios',
				type: 'link',
				href: '/administration-portfolio',
				actions: [AllowedAction.ChangeConfiguration]
			},
			{
				title: 'Options',
				type: 'link',
				href: '/administration-option',
				actions: [AllowedAction.ChangeConfiguration]
			},
			{
				title: 'Calculator',
				type: 'link',
				href: '/calculator-configurator',
				actions: [AllowedAction.ChangeConfiguration]
			},
			{
				title: 'Custom Fields',
				type: 'link',
				href: '/custom-field-configurator',
				actions: [AllowedAction.ChangeConfiguration]
			}
		]
	}
];

if (process.env.NODE_ENV === 'development') {
	// add dev showcase to the menu
	navMenu.push({
		title: 'DEV SHOWCASE',
		type: 'link',
		href: '/dev-showcase',
		actions: []
	});
	// add legacy offer in dev mode
	navMenu[1].submenu?.unshift({
		title: 'New standard offer',
		type: 'link',
		href: '/standard-offer',
		actions: [AllowedAction.CreateOffer]
	});
}

const configNavMenuRoutes = (actions: AllowedAction[]) => {
	return navMenu
		.filter(
			(nav: Menu) =>
				nav.actions?.length === 0 || nav.actions?.some((action) => actions.includes(action))
		)
		.map((fnav: Menu) => {
			let { submenu } = fnav;
			if (submenu) {
				fnav.submenu = submenu.filter(
					(sub: Menu) =>
						sub.actions?.length === 0 ||
						sub.actions?.some((action) => actions.includes(action))
				);
			}
			return { ...fnav };
		});
};

export default configNavMenuRoutes;
